import React from "react";
import { ThreeHorseLoading } from "react-loadingg";

const LoadingAtom = () => {
  return (
    <>
      <div className="row mb-4">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "80vh" }}
        >
          <div className="d-flex align-items-center">
            <h4>Mohon Tunggu...</h4>&nbsp;
            <ThreeHorseLoading color="#df1760" size="large" />
          </div>
        </div>
      </div>
    </>
  );
};

export default LoadingAtom;
